import { render, staticRenderFns } from "./TableForm1.vue?vue&type=template&id=5ea7f910&scoped=true"
import script from "./TableForm1.vue?vue&type=script&lang=ts"
export * from "./TableForm1.vue?vue&type=script&lang=ts"
import style0 from "./TableForm1.vue?vue&type=style&index=0&id=5ea7f910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea7f910",
  null
  
)

export default component.exports